import { Button } from '@campgladiator/cgui-core.atoms.button'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Input } from '@campgladiator/cgui-core.atoms.input'
import { Loader } from '@campgladiator/cgui-core.atoms.loader'
import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { FormPart } from '@campgladiator/cgui-core.molecules.form-part'

const LoginContainer = ({
  formData: { email, password },
  inputChange,
  onLoginSubmit,
  isLoading = false,
}) => {
  return (
    <div className="login-container">
      <Card raised>
        <Heading type="h2" className="login-container__header">
          Log In
        </Heading>
        <Paragraph className="login-container__header-text" weight="book">
          Log in to access your challenge dashboard
        </Paragraph>
        <form
          className="form login-form"
          onSubmit={onLoginSubmit}
          data-testid="loginForm"
        >
          <FormPart forId="email">
            <Input
              label="Email Address"
              placeholder="Email"
              required
              title="Email Address"
              value={email}
              id="email"
              type="text"
              onChange={inputChange}
            />
          </FormPart>
          <FormPart forId="password">
            <Input
              label="Password"
              placeholder="Password"
              value={password}
              required
              id="password"
              type="password"
              onChange={inputChange}
            />
          </FormPart>
          <div className="login-form__btn-wrap">
            <Button
              primary
              solid
              className="login-form__btn-login"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? <Loader emphasis="negative" /> : 'Log in'}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  )
}

export default LoginContainer
